export const normalizeUrl = (title: string, id: number | undefined): string => {
  return encodeURIComponent(`${title.trim().replace(/\s/g, '-').toLowerCase()}-${id}`)
}
